// extracted by mini-css-extract-plugin
export var carrierIconPlaceholder = "_89-1";
export var dragButton = "_89-5";
export var sortableCell = "_89-4";
export var sortableNameCell = "_89-3";
export var sortableRow = "_89-0";
export var tableHeader = "_89-6";
export var tableHeaderWithCardHeader = "_89-7";
export var weightInputRow = "_89-2";